// extracted by mini-css-extract-plugin
module.exports = {"companyDetailCard":"card_companyDetailCard__OKIL1","cardTitle":"card_cardTitle__nlQA_","wrapper":"card_wrapper__91G_f"};